import React from 'react';
import { useTranslation, Trans } from "react-i18next"
import Close from '../../assets/icons/close.svg';
import Search from '../../assets/icons/search.svg';

const SearchToggle = React.memo(({ open, ...props }) => {
  const { t } = useTranslation();
  return (
    <button className="search-toggle" {...props}>
      {open ? <Close /> : <Search />}
      <span>{open ? t('search_bar.close') : t('search_bar.search')}</span>
    </button>
  )
});

export default SearchToggle;
